// extracted by mini-css-extract-plugin
export default {"alt-text":"dhhs-alt-text","altText":"dhhs-alt-text"};